import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ListadaAgrupada, ConfigService } from '../../../infrastructure/services/config.service';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Component({
    templateUrl: './configurar.productreport.component.html',
})
export class ConfigurarProductReportComponent implements OnInit, OnDestroy {
    readonly level = "ProductReport";
    organizationCode:string;
    systemCode: string;
    businessCode: string;
    productcode: string;

    productReportCode: string;

    grupos: Observable<ListadaAgrupada[]>;
    cargando: Boolean = true;
    subsGetConfiguracion: Subscription;

    constructor(private aRoute: ActivatedRoute, private configService: ConfigService) { }

    ngOnInit() {

        this.aRoute.params.subscribe((params: Params) => {
            // Parametros URL
            this.organizationCode = params['codorganizacion'];
            this.systemCode = params['codsistema'];
            this.businessCode=params['codnegocio'];
            this.productcode=params['codproducto'];
            this.productReportCode = params['productReportCode'];
            this.grupos = this.configService.getConfiguracion(
                this.organizationCode,
                this.systemCode, 
                this.businessCode, 
                this.productcode, 
                this.level, 
                this.productReportCode);
        });
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/productReport/configurar.productReport.component.ts